import React from "react";
import styles from "./TermsCondition.module.css";
import TitleText, { TitleTextSize } from "../../components/TitleText";
import { useTranslation } from "react-i18next";
import Paragraph, { ParagraphSize } from "../../components/Paragraph";
import MainTemplate from "../Templates/MainTemplate";
import Footer from "../../components/footer/Footer";

interface Item {
  title?: string;
  description: string[];
  subDesc?: string;
  isBullet?: boolean;
}

interface TermsInfoProps {
  item: Item[];
}

const TermsInfo: React.FC<TermsInfoProps> = ({ item }) => {
  return (
    <div>
      {item.map((data, index) => (
        <div key={index} className={styles["info-container"]}>
          {data.title && (
            <Paragraph
              size={ParagraphSize.paragraph2}
              classNameStyle={styles["title-highlight"]}
            >
              {data.title}
            </Paragraph>
          )}

          {!data.isBullet ? (
            <>
              {data.description.map((info, index) => (
                <Paragraph size={ParagraphSize.paragraph2} key={index}>
                  {info}
                </Paragraph>
              ))}
            </>
          ) : (
            <>
              {data.subDesc && (
                <Paragraph size={ParagraphSize.paragraph2}>
                  {data.subDesc}
                </Paragraph>
              )}

              <ol className={styles["list"]}>
                {data.description.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ol>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

const TermsCondition = () => {
  const { t } = useTranslation();

  const list = t("terms_page.term_list", {
    returnObjects: true,
  }) as Item[];

  const body = (
    <div className={styles["body-container"]}>
      <div className={styles["main-container"]}>
        <div className={styles["title-container"]}>
          <TitleText size={TitleTextSize.heading2}>
            {t("terms_page.title")}
          </TitleText>
        </div>
        <TermsInfo item={list} />
      </div>
    </div>
  );

  return <MainTemplate body={body} footer={<Footer />} />;
};

export default TermsCondition;
